
const isCardExpired = (month, year) => {
    // month payload format  04 || 4
    // year payload format 2024

    // Get the current date
    if (month <= 0 || month > 12) {
        return 'invalid month';
    }
    var currentDate = new Date();
    var currentYear = currentDate.getFullYear();
    var currentMonth = currentDate.getMonth() + 1; // Note: January is 0

    // Convert input to numbers
    month = Number(month);
    year = Number(year);

    // Check if the expiration year is in the past
    if (year < currentYear) {
        return 'expired';
    }

    // Check if the expiration year is in the current year, but the month is in the past
    if (year === currentYear && month < currentMonth) {
        return 'expired';
    }

    // Otherwise, the card is valid
    return 'active';
}


export default isCardExpired;